document.addEventListener("DOMContentLoaded", function () {
  const sliderContainer = document.querySelector(".prodVideoSlider");

  // ✅ Load liked videos from localStorage
  const likedVideos = JSON.parse(localStorage.getItem("likedVideos") || "[]");

  // ✅ Delegated Like Button Click Handler
  sliderContainer?.addEventListener("click", async function (e) {
    const btn = e.target.closest(".like-btn");
    if (!btn) return;

    const parentCard = btn.closest(".videoWrap");
    const video = parentCard?.querySelector("video");
    const website = document.body.getAttribute("data-website");
    const title = parentCard?.dataset.title || "";
    const source = video?.querySelector("source");
    const url = source?.getAttribute("src");
    const likeCountSpan = btn.querySelector(".like-count");

    if (!url || !website || !title) return;

    // ✅ Check if already liked (persistent)
    if (likedVideos.includes(url)) {
      console.log("Already liked → skipping");
      return;
    }

    if (btn.dataset.disabled === "true") return;
    btn.dataset.disabled = "true";
    btn.classList.add("disabled");

    const formData = new FormData();
    formData.append("website", website);
    formData.append("title", title);
    formData.append("url", url);

    try {
      const response = await fetch(
        "https://digital.agarolifestyle.com/luvlap_api/Like-App/video-like.php",
        { method: "POST", body: formData }
      );
      const result = await response.json();
      console.log("Like update →", result);

      if (result.status === "success") {
        const count = parseInt(result.total_likes) || 0;
        likeCountSpan.textContent = count > 0 ? `(${count})` : "";
        likeCountSpan.style.display = count > 0 ? "inline-block" : "none";

        // ✅ Mark video as liked in localStorage
        likedVideos.push(url);
        localStorage.setItem("likedVideos", JSON.stringify(likedVideos));
      }
    } catch (err) {
      console.error("Like Error", err);
    }
  });

  // ✅ Populate like counts
  window.initAllCards = async function () {
    const videoCards = document.querySelectorAll(".prodVideoSlider .videoWrap");
    const website = document.body.getAttribute("data-website");
    if (!website) return;

    videoCards.forEach(async (card) => {
      const videoEl = card.querySelector("video");
      const sourceEl = videoEl?.querySelector("source");
      const videoURL = sourceEl?.getAttribute("src");
      const likeCountSpan = card.querySelector(".like-btn .like-count");
      const btn = card.querySelector(".like-btn");

      if (!videoURL || !likeCountSpan) return;

      // ✅ If already liked, mark it disabled
      if (likedVideos.includes(videoURL)) {
        btn.classList.add("disabled");
        btn.dataset.disabled = "true";
      }

      const formData = new FormData();
      formData.append("url", videoURL);
      formData.append("website", website);

      try {
        const response = await fetch(
          "https://digital.agarolifestyle.com/luvlap_api/Like-App/get-video-like.php",
          { method: "POST", body: formData }
        );

        const result = await response.json();
        const count = parseInt(result.total_likes) || 0;
        likeCountSpan.textContent = count > 0 ? `(${count})` : "";
        likeCountSpan.style.display = count > 0 ? "inline-block" : "none";
      } catch (err) {
        console.error("Like count fetch failed:", err);
        likeCountSpan.textContent = "";
        likeCountSpan.style.display = "none";
      }
    });
  };

  initAllCards();
});
